function error(options, msg) {
  if (options.onError) {
    options.onError(new Error(msg));
  }
}

export default error;
//# sourceMappingURL=error.js.map